import { styled } from "@mui/material/styles";

const StyledCreateProfile = styled("div")(
  ({ theme }) => `
  .create-profile-wrap {
  width: 60%;
  margin: 0 auto;
  padding: 30px 30px 0px 30px;
  background: white;

  @media screen and (max-width: 1025px) {
    width: 80%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}
.create-profile-header {
  margin-top: 20px; 
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 32px;
  font-style: normal;
  line-height: normal;
  @media screen and (max-width: 1025px) {
    font-size: 28px;
  }
  @media screen and (max-width: 480px) {
    font-size: 24px;
  }  
}
.create-profile-sub-header{
  margin-top: 12px;
  margin-bottom: 32px;
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}
.create-profile-textfeilds {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.create-profile-store {
  display: flex;
  gap: 20px;
  @media screen and (max-width: 480px) {
    flex-direction: column;
  }  
}
.text-feilds {
  width: 100%;
}
.topic-header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  margin: 20px 0px 10px;
}
.tags-component {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
  .tags {
    border-radius: 0px;
    background-color: ${theme.palette.customColor.white};
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    font-family: Lexend;
    color: ${theme.palette.primary.main};
    font-weight: 400;
    font-size: 10.6px;
    font-style: normal;
    line-height: 13.25px;
    padding: 0px 10px;
  }
  .selected-tag {
    border-radius: 0px;
    background-color: ${theme.palette.secondary.main};
    border: 0px solid ${theme.palette.customColor.secondaryThird};
    font-family: Lexend;
    color: ${theme.palette.customColor.white};
    font-weight: 400;
    font-size: 10.6px;
    font-style: normal;
    line-height: 13.25px;
    padding: 0px 10px;
  }
  .submit-btn {
    width: 100%;
    padding: 10px;
    margin: 20px 0px 0px 0px;
    font-size: 16px;
    font-weight: 400;
    text-transform: none;
    border-radius: 0px;
  }
    .btn-wrap {
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: center;
    margin-bottom: 40px;
    }
  .go-back-btn {
    text-decoration: underline;
    cursor: pointer;
    font-family: Lexend;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: ${theme.palette.primary.main};
    margin-top: 10px;
  }  
  .image-wrap {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin: 20px 0px;
    cursor: pointer;
  }
  .profile-picture {
    border: 1.24px dashed #A78D78;
    border-radius: 3.56px;
    width: 86px;
    height: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .add-icon {
    font-size: 40px;
    color: #A78D78
  }
  .cropped-image-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }  
  .cropped-image {
   width: 100%;
   height: 100%;
   object-fit: cover;
   border-radius: 3.56px;
  }  
  .modal-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .modal-content {
    width: 80%;
    height: 80%;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .image-crop-display {
    width: 100%;
    height: 80%;
  }
  .profile-picture-image {
    border: 1.24px solid #A78D78;
    border-radius: 3.56px;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .image-close {
    position: absolute;
    border-radius: 50%;
    background-color: #A78D78;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    top: -8px;
    right: -7px;
    cursor: pointer;
  }
  .create-textfeilds {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }                                
`
);

export default StyledCreateProfile;
